// extracted by mini-css-extract-plugin
export var closeButton = "_ob-2";
export var closeButtonIcon = "_ob-3";
export var lightboxContent = "_ob-1";
export var lightboxOverlay = "_ob-0";